// Перехват ошибок инициализации в скрипте smartCaptcha
let smartCaptchaInitError = null;
const NO_SCRIPT_TEXT = 'Не найден скрипт SmartCaptcha';

const onInitError = (event) => {
    if (event.reason?.message?.includes('[SmartCaptcha] ')) {
        event.preventDefault();

        smartCaptchaInitError = new Error('Ошибка загрузки smartCaptcha');

        window.removeEventListener('unhandledrejection', onInitError);
    }
};

window.addEventListener('unhandledrejection', onInitError);

// Промис загрузки smartCaptcha + ключ
let loadCaptchaPromise;
const loadCaptcha = () => {
    if (loadCaptchaPromise) {
        return loadCaptchaPromise;
    }

    loadCaptchaPromise = loadCaptchaPromise || new Promise((resolve, reject) => {
        // Ищем тег скрипта в документе. <script id="smartcaptcha" ...>
        const script = document.getElementById('smartcaptcha');

        if (!script) {
            reject(new Error(NO_SCRIPT_TEXT));
            return;
        }

        // Разрешаем Promise, когда скрипт загрузится
        script.addEventListener('load', () => {
            if (window.smartCaptcha) {
                resolve({
                    captcha: window.smartCaptcha,
                    key: script.dataset.key ?? '',
                });
            } else {
                reject(new Error('SmartCaptcha не инициализировалась после загрузки'));
            }
        });

        script.addEventListener('error', () => {
            reject(new Error('Ошибка загрузки smartCaptcha'));
        });
    });

    return loadCaptchaPromise;
};

const initCaptcha = async (formDom) => {
    try {
        let error = null;
        const { captcha: smartCaptcha, key: sitekey } = await loadCaptcha();
        const containerDom = document.createElement('div');

        formDom.appendChild(containerDom);

        // Рендер капчи в форму
        const captchaWidgetId = smartCaptcha.render(containerDom, {
            sitekey,
            invisible: true,
            // Гарантируем заполнение токена в поле 'smart-token'
            callback: (token) => {
                let tokenInputDom = formDom.querySelector('[name="smart-token"]');

                if (!tokenInputDom) {
                    tokenInputDom = formDom.createElement('input');
                    tokenInputDom.name = 'smart-token';
                    tokenInputDom.type = 'hidden';
                    formDom.appendChild(containerDom);
                }

                tokenInputDom.value = token;
            }
        });

        // Подписки на ошибки
        smartCaptcha.subscribe(
            captchaWidgetId,
            'network-error',
            () => {
                error = new Error('Возникла сетевая ошибка');
            }
        );

        smartCaptcha.subscribe(
            captchaWidgetId,
            'javascript-error',
            (err) => {
                console.error(err);
                error = new Error('Возникла критическая ошибка JS');
            }
        );

        smartCaptcha.subscribe(
            captchaWidgetId,
            'token-expired',
            () => {
                error = new Error('Токен прохождения проверки стал невалидным');
            }
        );

        let unsubscribeOnVisible = () => {};
        let unsubscribeOnHidden = () => {};
        let unsubscribeOnSuccess = () => {};

        // Отдаем промис выполнения капчи
        return (options = {}) => new Promise((resolve, reject) => {
            const { onOpen = () => {}, onClose = () => {} } = options;

            unsubscribeOnVisible();
            unsubscribeOnHidden();
            unsubscribeOnSuccess();
            smartCaptcha.reset(captchaWidgetId);

            unsubscribeOnVisible = smartCaptcha.subscribe(
                captchaWidgetId,
                'challenge-visible',
                onOpen
            );

            unsubscribeOnHidden = smartCaptcha.subscribe(
                captchaWidgetId,
                'challenge-hidden',
                onClose
            );

            unsubscribeOnSuccess = smartCaptcha.subscribe(
                captchaWidgetId,
                'success',
                () => {
                    resolve();
                    error = null;
                }
            );

            smartCaptcha.execute(captchaWidgetId);

            if (smartCaptchaInitError || error) {
                console.error(smartCaptchaInitError || error);
                reject(smartCaptchaInitError || error);
                error = null;
            }
        });
    } catch (error) {
        console.error(error);

        if (error.message === NO_SCRIPT_TEXT) {
            // Если нет скрипта то пропускаем капчу
            return () => new Promise((resolve) => resolve());
        }

        // Отдаем промис с ошибкой загрузки капчи
        return () => new Promise((_, reject) => reject(error));
    }
};

export default initCaptcha;
